import {
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  IconButton,
  InputAdornment,
  Popover,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { MenuItem } from "@mui/material";
import AntSwitch from "../AntSwitch";
import FrameworkSwitches from "../FrameworkSwitches";
import {
  DEFAULT_FRAMEWORKS,
  sameFrameworks,
} from "../../shared/constants/frameworks";
import * as Yup from "yup";
import CancelIcon from "@mui/icons-material/Cancel";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import axiosInstance from "../../services/axiosInstance";
import { SA_ORG_REGISTRATION } from "../../shared/constants/apiEndpoints";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

interface InviteDrawerProps {
  onCloseDrawer: () => void;
  InviteTable: () => void;
}

const getValidationSchema = (subscriptionType: string) => {
  let onPremMin = 30,
    onPremMax: number | undefined = undefined,
    cloudMin = 30,
    cloudMax: number | undefined = undefined,
    validityMin = 13,
    validityMax = 365;
  if (subscriptionType.trim() === "Free Trial") {
    onPremMax = 30;
    cloudMax = 50;
    validityMax = 14;
  } else if (subscriptionType.trim() === "Free Custom") {
    validityMin = 30;
    validityMax = 90;
  } else if (subscriptionType.trim() === "Paid Custom") {
    validityMin = 30;
    validityMax = 365;
  }
  return Yup.object().shape({
    name: Yup.string()
      .max(256, "Name contain maximum 256 characters")
      .required(" Name is required"),
    address: Yup.string()
      .required("Address is required")
      .max(64, "Address contain maximum 64 characters"),
    city: Yup.string().required("City is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string(),
    pincode: Yup.string()
      .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits")
      .required("Pincode is required"),
    firstname: Yup.string()
      .required("First name is required")
      .max(64, "First name contain maximum 64 characters"),
    lastname: Yup.string()
      .required("Last name is required")
      .max(64, "Last name contain maximum 64 characters"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required")
      .max(64, "Email  contain maximum 64 characters"),
    contact: Yup.string()
      .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit contact number")
      .required("Contact is required"),
    leadSource: Yup.string()
      .required("Lead Source is required")
      .max(64, "Lead source contain maximum 64 characters"),
    leadSourceContact: Yup.string()
      .required("Please enter a valid 10-digit contact number")
      .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit contact number"),
    organisationWebsite: Yup.string()
      .url("Invalid URL format")
      .required("Organization Website is required"),
    accountManager: Yup.string(),
    accountManagerEmail: Yup.string().email("Invalid email format"),
    accountManagerContact: Yup.string(),
    subscriptionType: Yup.string().required("Subscription Type is required"),
    deploymenttype: Yup.string().required("Deployment Type is required"),
    inventoryType: Yup.string().required("Inventory Type is required"),
    onPremAssets: Yup.number()
      // .typeError("On-prem Assets must be a number")
      // .min(onPremMin, `On-prem Assets must be at least ${onPremMin}`)
      // .test('max', `On-prem Assets must be at most ${onPremMax ?? 'unlimited'}`,(v) => (typeof v === 'number') && (onPremMax === undefined || v <= onPremMax))
      .required("On-prem Assets is required"),
    cloudResources: Yup.number()
      // .typeError("Cloud Resources must be a number")
      // .min(cloudMin, `Cloud Resources must be at least ${cloudMin}`)
      // .test('max', `Cloud Resources must be at most ${cloudMax ?? 'unlimited'}`,(v) => (typeof v === 'number') && (cloudMax === undefined || v <= cloudMax))
      .required("Cloud Resources is required"),
    validity: Yup.number()
      .typeError("Validity must be a number")
      .min(validityMin, `Validity must be at least ${validityMin} days`)
      .max(validityMax, `Validity must be at most ${validityMax} days`)
      .required("Validity is required"),
  });
};

const InviteOrgDrawer: React.FC<InviteDrawerProps> = ({
  onCloseDrawer,
  InviteTable,
}) => {

  const subscriptionType = ["Free Trial", "Free Custom", "Paid Custom"];
  const deploymentType = ["On-prem", "SaaS"];
  // const deploymentType = ["SaaS"];
  const inventoryType = [
    "On-prem & Cloud",
    "On-prem Assets",
    "Cloud Resources",
  ];
  // const validation_schema = Yup.object().shape({
  //   name: Yup.string()
  //     .max(64, "Name must be at most 64 characters")
  //     .required(" Name is required"),
  //   address: Yup.string().required("Address is required")
  //   .max(64, "Address must be at most 64 characters"),
  //   city: Yup.string().required("City is required"),
  //   country: Yup.string().required("Country is required"),
  //   state: Yup.string(),
  //   pincode: Yup.string()
  //     .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits")
  //     .required("Pincode is required"),
  //   firstname: Yup.string().required("First name is required")
  //   .max(64, "First name must be at most 64 characters"),
  //   lastname: Yup.string().required("Last name is required")
  //   .max(64, "Last name must be at most 64 characters"),
  //   email: Yup.string()
  //     .email("Invalid email format")
  //     .required("Email is required")
  //     .max(64, "Email must be at most 64 characters"),
  //   contact: Yup.string()
  //     .matches(/^[0-9]{10}$/, "Contact must be exactly 10 digits")
  //     .required("Contact is required"),
  //   leadSource: Yup.string().required("Lead Source is required")
  //   .max(64, "Lead source must be at most 64 characters"),
  //   leadSourceContact: Yup.string().required("Lead Source Contact is required"),
  //   organisationWebsite: Yup.string()
  //     .url("Invalid URL format")
  //     .required("Organization Website is required"),
  //   accountManager: Yup.string(),
  //   accountManagerEmail: Yup.string().email("Invalid email format"),
  //   accountManagerContact: Yup.string(),
  //   subscriptionType: Yup.string().required("Subscription Type is required"),
  //   deploymenttype: Yup.string().required("Deployment Type is required"),
  //   inventoryType: Yup.string().required("Inventory Type is required"),
  //   // onPremAssets: Yup.string().when("inventoryType", {
  //   //   is: (val: string) => val === "On-prem + cloud",
  //   //   then: Yup.string().required("On-prem Assets is required"),
  //   //   otherwise: Yup.string(),
  //   // }),
  //   // cloudResources: Yup.string().when("inventoryType", {
  //   //   is: (val: string) => val === "On-prem + cloud",
  //   //   then: Yup.string().required("Cloud Resources is required"),
  //   //   otherwise: Yup.string(),
  //   // }),
  //   // validity: Yup.string().required("Validity is required"),
  // });

  // const InviteTablerefetch = () => {
  //   //  setLoading(true);
  //   axiosInstance.get(SA_ORGANIZATIONS_LIST).then((res) => {
  //     const organizationsData = res.data?.data || res.data;
  //   });
  // };
  // useEffect(() => {
  //   InviteTablerefetch();
  // }, []);
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([
    dayjs(),
    dayjs().add(14, "day"),]);
  const [dateRangeAnchor, setDateRangeAnchor] = useState<HTMLElement | null>(null);

  const formik = useFormik({
    initialValues: {
      name: "",
      address: "",
      city: "",
      country: "",
      state: "",
      pincode: "",
      firstname: "",
      lastname: "",
      email: "",
      contact: "",
      leadSource: "",
      leadSourceEmail: "",
      leadSourceContact: "",
      organisationWebsite: "",
      accountManager: "",
      accountManagerEmail: "",
      accountManagerContact: "",
      subscriptionType: "",
      deploymenttype: "",
      inventoryType: "",
      onPremAssets: "",
      cloudResources: "",
      validity: "",
      sso_enabled: false,
      frameworks: [...DEFAULT_FRAMEWORKS],
    },
    validationSchema: getValidationSchema(""),
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      try {
        // Helper function to normalize strings: trim and replace multiple spaces with single space
        const normalizeString = (str: string | undefined): string => {
          if (!str) return "";
          return str.trim().replace(/\s+/g, " ");
        };

        // Transform form values to match API payload structure and normalize all string fields
        const payload = {
          organization_name: normalizeString(values.name),
          organization_address: normalizeString(values.address),
          organization_website: normalizeString(values.organisationWebsite),
          country: normalizeString(values.country),
          state: normalizeString(values.state),
          city: normalizeString(values.city),
          pin_code: normalizeString(values.pincode),
          firstname: normalizeString(values.firstname),
          lastname: normalizeString(values.lastname),
          organization_email: normalizeString(values.email),
          contact: normalizeString(values.contact),
          lead_source: normalizeString(values.leadSource),
          lead_source_email: normalizeString(values.leadSourceEmail),
          lead_source_contact: normalizeString(values.leadSourceContact),
          account_manager: normalizeString(values.accountManager),
          account_manager_email: normalizeString(values.accountManagerEmail),
          account_manager_contact: normalizeString(values.accountManagerContact),
          subscription_type: normalizeString(values.subscriptionType),
          deployment_type: normalizeString(values.deploymenttype),
          inventory_type: normalizeString(values.inventoryType),
          on_prem_assets: parseInt(values.onPremAssets) || 0,
          cloud_resources: parseInt(values.cloudResources) || 0,
          validity_days: parseInt(values.validity) || 90,
          sso_enabled: values.sso_enabled,
          // Sent only when changed, so an untouched org keeps following the defaults
          ...(sameFrameworks(values.frameworks, DEFAULT_FRAMEWORKS)
            ? {}
            : { frameworks: values.frameworks }),
        };
        console.log("values.sso_enabled", values.sso_enabled);
        console.log("=== PAYLOAD BEING SENT (ENCRYPTED) ===");
        console.log("Raw payload:", JSON.stringify(payload, null, 2));
        console.log("Payload keys:", Object.keys(payload));
        console.log("========================");

        // Use encrypted API call utility with Bearer token
        const response = await axiosInstance.post(SA_ORG_REGISTRATION, payload);
        console.log("API Response:", response.data);        
        if (response?.data?.status === 200) {
          toast.success(response?.data?.message);
          formik.resetForm();
          onCloseDrawer();
          InviteTable();
        }
        // Navigate to organization table after successful registration
        // navigate("/organisation-table");

        // InviteTablerefetch();
      } catch (error: any) {
        console.error("Error registering organization:", error);
        // Handle error (show toast notification, etc.)
        toast.error(error?.response?.data?.message);
      }
    },
  });

  // Update validation schema when subscriptionType changes
  useEffect(() => {
    formik.setFormikState((prev) => ({
      ...prev,
      validationSchema: getValidationSchema(formik.values.subscriptionType),
    }));
    // eslint-disable-next-line
  }, [formik.values.subscriptionType]);

  const [fieldState, setFieldState] = React.useState<{
    onPremAssets: { disabled: boolean; min: number; max: number | undefined; value: string };
    cloudResources: { disabled: boolean; min: number; max: number | undefined; value: string };
    validity: { disabled: boolean; min: number; max: number | undefined; value: string };
    validityOptions: number[];
  }>({
    onPremAssets: { disabled: false, min: 30, max: undefined, value: "" },
    cloudResources: { disabled: false, min: 30, max: undefined, value: "" },
    validity: { disabled: false, min: 13, max: 365, value: "" },
    validityOptions: [13, 30, 60, 90, 180, 365],
  });

  // Initialize date range on mount
  useEffect(() => {
    if (!dateRange[0] || !dateRange[1]) {
      setDateRange([dayjs(), dayjs().add(14, "day")]);
      formik.setFieldValue("validity", "14");
    }
  }, []);

  // Calculate validity days from date range
  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      const days = dateRange[1].diff(dateRange[0], "day");
      formik.setFieldValue("validity", days.toString());
    }
  }, [dateRange]);

  useEffect(() => {
    const subType = formik.values.subscriptionType.trim();
    const invType = formik.values.inventoryType;
    if (subType === "Free Trial") {
      setFieldState({
        onPremAssets: { disabled: true, min: 30, max: 30, value: "30" },
        cloudResources: { disabled: true, min: 50, max: 50, value: "50" },
        validity: { disabled: true, min: 14, max: 14, value: "14" },
        validityOptions: [14],
      });
      formik.setFieldValue("onPremAssets", "30");
      formik.setFieldValue("cloudResources", "50");
      formik.setFieldValue("validity", "14");
      // Set date range for Free Trial (14 days)
      setDateRange([dayjs(), dayjs().add(14, "day")]);
    } else if (subType === "Free Custom" || subType === "Paid Custom") {
      if (invType === "On-prem & Cloud") {
        setFieldState({
          onPremAssets: {
            disabled: false,
            min: 30,
            max: undefined,
            value: "30",
          },
          cloudResources: {
            disabled: false,
            min: 30,
            max: undefined,
            value: "30",
          },
          validity: {
            disabled: false,
            min: 30,
            max: subType === "Free Custom" ? 90 : 365,
            value: "30",
          },
          validityOptions:
            subType === "Free Custom"
              ? [30, 60, 90]
              : [30, 60, 90, 180, 365],
        });
        formik.setFieldValue("onPremAssets", "30");
        formik.setFieldValue("cloudResources", "30");
        formik.setFieldValue("validity", "30");
        // Set default date range (30 days)
        setDateRange([dayjs(), dayjs().add(30, "day")]);
      } else if (invType === "On-prem Assets") {
        setFieldState({
          onPremAssets: {
            disabled: false,
            min: 30,
            max: undefined,
            value: "30",
          },
          cloudResources: { disabled: true, min: 0, max: 0, value: "0" },
          validity: {
            disabled: false,
            min: 30,
            max: subType === "Free Custom" ? 90 : 365,
            value: "30",
          },
          validityOptions:
            subType === "Free Custom"
              ? [30, 60, 90]
              : [30, 60, 90, 180, 365],
        });
        formik.setFieldValue("onPremAssets", "30");
        formik.setFieldValue("cloudResources", "0");
        formik.setFieldValue("validity", "30");
        // Set default date range (30 days)
        setDateRange([dayjs(), dayjs().add(30, "day")]);
      } else if (invType === "Cloud Resources") {
        setFieldState({
          onPremAssets: { disabled: true, min: 0, max: 0, value: "0" },
          cloudResources: {
            disabled: false,
            min: 30,
            max: undefined,
            value: "30",
          },
          validity: {
            disabled: false,
            min: 30,
            max: subType === "Free Custom" ? 90 : 365,
            value: "30",
          },
          validityOptions:
            subType === "Free Custom"
              ? [30, 60, 90]
              : [30, 60, 90, 180, 365],
        });
        formik.setFieldValue("onPremAssets", "0");
        formik.setFieldValue("cloudResources", "30");
        formik.setFieldValue("validity", "30");
        // Set default date range (30 days)
        setDateRange([dayjs(), dayjs().add(30, "day")]);
      }
    } else {
      setFieldState({
        onPremAssets: {
          disabled: false,
          min: 30,
          max: undefined,
          value: formik.values.onPremAssets,
        },
        cloudResources: {
          disabled: false,
          min: 30,
          max: undefined,
          value: formik.values.cloudResources,
        },
        validity: {
          disabled: false,
          min: 30,
          max: 365,
          value: formik.values.validity,
        },
        validityOptions: [13, 30, 60, 90, 180, 365],
      });
    }
    // eslint-disable-next-line
  }, [formik.values.subscriptionType, formik.values.inventoryType]);

  useEffect(() => {
    const inventory = formik.values.inventoryType;
    if (inventory === "On-prem Assets") {
      setFieldState((prev) => ({
        ...prev,
        cloudResources: { ...prev.cloudResources, disabled: true },
        onPremAssets: { ...prev.onPremAssets, disabled: false },
      }));
      formik.setFieldValue("cloudResources", "0");
      if (
        !formik.values.onPremAssets ||
        parseInt(formik.values.onPremAssets) < 30
      ) {
        formik.setFieldValue("onPremAssets", "30");
      }
    } else if (inventory === "Cloud Resources") {
      setFieldState((prev) => ({
        ...prev,
        onPremAssets: { ...prev.onPremAssets, disabled: true },
        cloudResources: { ...prev.cloudResources, disabled: false },
      }));
      formik.setFieldValue("onPremAssets", "0");
      if (
        !formik.values.cloudResources ||
        parseInt(formik.values.cloudResources) < 30
      ) {
        formik.setFieldValue("cloudResources", "30");
      }
    } else if (formik.values.subscriptionType.trim() === "Free Trial") {
      // Already handled by subscriptionType effect
    } else {
      setFieldState((prev) => ({
        ...prev,
        cloudResources: { ...prev.cloudResources, disabled: false },
        onPremAssets: { ...prev.onPremAssets, disabled: false },
      }));
      if (formik.values.cloudResources === "0") {
        formik.setFieldValue("cloudResources", "30");
      }
      if (formik.values.onPremAssets === "0") {
        formik.setFieldValue("onPremAssets", "30");
      }
    }
    // eslint-disable-next-line
  }, [formik.values.inventoryType, formik.values.subscriptionType]);

  const [inventoryTypeDisabled, setInventoryTypeDisabled] =
    React.useState(true);

  useEffect(() => {
    const subType = formik.values.subscriptionType.trim();
    if (!subType) {
      setInventoryTypeDisabled(true);
    } else if (subType === "Free Trial") {
      formik.setFieldValue("inventoryType", "On-prem & Cloud");
      setInventoryTypeDisabled(true);
    } else {
      setInventoryTypeDisabled(false);
    }
    // eslint-disable-next-line
  }, [formik.values.subscriptionType]);

  return (
    <div style={{ overflow: "auto" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontWeight: "bold", padding: 2, fontSize: "16px" }}
        >
          Invite Organization
        </Typography>
        <IconButton
          style={{
            color: "#A6A5B6",
          }}
        >
          <CancelIcon onClick={onCloseDrawer} />
        </IconButton>
      </div>

      <Divider />

      <div
        style={{
          padding: 20,
          overflowY: "auto",
          height: "calc(100vh - 100px)",
        }}
        className="scroll"
      >
        <Typography variant="body2" fontWeight="bold">
          Organization Information
        </Typography>

        <form onSubmit={formik.handleSubmit} style={{ flexGrow: 1 }}>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              sx={{ mt: 2 }}
              id="name"
              label="Name"
              variant="outlined"
              name="name"
              required
              fullWidth
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                formik.setFieldValue("name", e.target.value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />

            <TextField
              sx={{ mt: 2 }}
              id="address"
              label="Address 1"
              variant="outlined"
              name="address"
              required
              fullWidth
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z0-9\s]/g, ""); // alphabets + numbers + spaces
                formik.setFieldValue("address", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.address}
              error={formik.touched.address && Boolean(formik.errors.address)}
              helperText={formik.touched.address && formik.errors.address}
            />
          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              id="City"
              label="City"
              variant="outlined"
              required
              fullWidth
              name="city"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // allow only letters + spaces
                formik.setFieldValue("city", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.city}
              error={formik.touched.city && Boolean(formik.errors.city)}
              helperText={formik.touched.city && formik.errors.city}
              inputProps={{ maxLength: 64 }}
            />

            <TextField
              id="Country"
              label="Country"
              variant="outlined"
              required
              fullWidth
              name="country"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // allow only letters + spaces
                formik.setFieldValue("country", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.country}
              error={formik.touched.country && Boolean(formik.errors.country)}
              helperText={formik.touched.country && formik.errors.country}
              inputProps={{ maxLength: 64 }}
            />
          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              id="State"
              label="State"
              variant="outlined"
              fullWidth
              name="state"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.state}
              error={formik.touched.state && Boolean(formik.errors.state)}
              helperText={formik.touched.state && formik.errors.state}
              inputProps={{ maxLength: 64 }}
            />
          </Box>
          <Box display="flex" gap={2}>
            <TextField
              sx={{ width: "49%" }}
              id="pincode"
              label="Pincode"
              variant="outlined"
              required
              fullWidth
              name="pincode"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              error={formik.touched.pincode && Boolean(formik.errors.pincode)}
              onChange={(e) => {
                // Allow only digits
                const value = e.target.value.replace(/\D/g, "");
                formik.setFieldValue("pincode", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.pincode}
              helperText={formik.touched.pincode && formik.errors.pincode}
              inputProps={{
                inputMode: "numeric", // Mobile keyboards will show number pad
                pattern: "[0-9]*", // Enforces numeric input
                maxLength: 6, // Optional: max 6 digits
              }}
            />
          </Box>
          <Typography variant="body2" fontWeight="bold" marginTop={2}>
            Admin Information
          </Typography>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              sx={{ mt: 2 }}
              id="firstname"
              label="First Name"
              variant="outlined"
              required
              fullWidth
              name="firstname"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // allow only letters & space
                formik.setFieldValue("firstname", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.firstname}
              error={
                formik.touched.firstname && Boolean(formik.errors.firstname)
              }
              helperText={formik.touched.firstname && formik.errors.firstname}
            />

            <TextField
              sx={{ mt: 2 }}
              id="lastname"
              label="Last Name"
              variant="outlined"
              required
              fullWidth
              name="lastname"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // allow only letters & space
                formik.setFieldValue("lastname", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.lastname}
              error={formik.touched.lastname && Boolean(formik.errors.lastname)}
              helperText={formik.touched.lastname && formik.errors.lastname}
            />
          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              sx={{ width: "49%" }}
              id="email"
              label="Email"
              variant="outlined"
              required
              fullWidth
              name="email"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <TextField
              sx={{ width: "49%" }}
              id="contact"
              label="Contact"
              variant="outlined"
              required
              fullWidth
              name="contact"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                formik.setFieldValue("contact", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.contact}
              error={formik.touched.contact && Boolean(formik.errors.contact)}
              helperText={formik.touched.contact && formik.errors.contact}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 10, // for example, 10 digits max
              }}
            />
          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              id="Lead Source"
              label="Lead Source"
              variant="outlined"
              required
              fullWidth
              name="leadSource"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // only letters + spaces
                formik.setFieldValue("leadSource", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.leadSource}
              error={
                formik.touched.leadSource && Boolean(formik.errors.leadSource)
              }
              helperText={formik.touched.leadSource && formik.errors.leadSource}
            />
            <TextField
              id="Leadmail"
              label="Lead Source Email"
              variant="outlined"
              required
              fullWidth
              name="leadSourceEmail"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.leadSourceEmail}
              error={
                formik.touched.leadSourceEmail &&
                Boolean(formik.errors.leadSourceEmail)
              }
              helperText={
                formik.touched.leadSourceEmail && formik.errors.leadSourceEmail
              }
            />
          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              sx={{ width: "49%" }}
              id="LeadSourceContact"
              label="Lead Source Contact"
              variant="outlined"
              required
              fullWidth
              name="leadSourceContact"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                formik.setFieldValue("leadSourceContact", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.leadSourceContact}
              inputProps={{ maxLength: 10 }}
              error={
                formik.touched.leadSourceContact &&
                Boolean(formik.errors.leadSourceContact)
              }
              helperText={
                formik.touched.leadSourceContact && formik.errors.leadSourceContact
              }
            />

          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              id="Organisation Website"
              label="Organization Website"
              variant="outlined"
              required
              fullWidth
              name="organisationWebsite"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.organisationWebsite}
              error={
                formik.touched.organisationWebsite &&
                Boolean(formik.errors.organisationWebsite)
              }
              helperText={
                formik.touched.organisationWebsite &&
                formik.errors.organisationWebsite
              }
            />
            <TextField
              id="Account Manager"
              label="Account Manager(Optional)"
              variant="outlined"
              fullWidth
              name="accountManager"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.accountManager}
              error={
                formik.touched.accountManager &&
                Boolean(formik.errors.accountManager)
              }
              helperText={
                formik.touched.accountManager && formik.errors.accountManager
              }
            />
          </Box>
          <Box display="flex" gap={2} className="mb_3">
            <TextField
              id="Account Manager Email"
              label="Account Manager Email(Optional)"
              variant="outlined"
              fullWidth
              name="accountManagerEmail"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.accountManagerEmail}
              error={
                formik.touched.accountManagerEmail &&
                Boolean(formik.errors.accountManagerEmail)
              }
              helperText={
                formik.touched.accountManagerEmail &&
                formik.errors.accountManagerEmail
              }
            />
            <TextField
              id="Account Manager Contact"
              label="Account Manager Contact(Optional)"
              variant="outlined"
              fullWidth
              name="accountManagerContact"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.accountManagerContact}
              error={
                formik.touched.accountManagerContact &&
                Boolean(formik.errors.accountManagerContact)
              }
              helperText={
                formik.touched.accountManagerContact &&
                formik.errors.accountManagerContact
              }
            />
          </Box>
          <Typography variant="body2" fontWeight="bold" marginTop={2}>
            Subscription
          </Typography>
          <Box display="flex" gap={2} className="mb_3">
            {/* Subscription Select */}
            <TextField
              sx={{ mt: 2 }}
              id="SubscriptionType"
              select
              label="Subscription Type"
              variant="outlined"
              // required
              fullWidth
              name="subscriptionType"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.subscriptionType}
              error={
                formik.touched.subscriptionType &&
                Boolean(formik.errors.subscriptionType)
              }
              helperText={
                formik.touched.subscriptionType &&
                formik.errors.subscriptionType
              }
            >
              {subscriptionType.map((e) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </TextField>

            {/* Deployment Select */}
            <TextField
              sx={{ mt: 2 }}
              id="DeploymentType"
              select
              label="Deployment Type"
              variant="outlined"
              required
              fullWidth
              name="deploymenttype"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.deploymenttype}
              error={
                formik.touched.deploymenttype &&
                Boolean(formik.errors.deploymenttype)
              }
              helperText={
                formik.touched.deploymenttype && formik.errors.deploymenttype
              }
            >
              {deploymentType.map((e) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box display="flex" gap={2}>
            {/* Inventory Select */}
            <TextField
              id="Inventory type"
              select
              label="Inventory Type"
              variant="outlined"
              required
              fullWidth
              name="inventoryType"
              InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.inventoryType}
              error={
                formik.touched.inventoryType &&
                Boolean(formik.errors.inventoryType)
              }
              helperText={
                formik.touched.inventoryType && formik.errors.inventoryType
              }
              disabled={inventoryTypeDisabled}
            >
              {inventoryType.map((e) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </TextField>
            {/* On-prem Assets */}
            {(() => {
              const onPremInputProps: Record<string, string> = {};
              if (typeof fieldState.onPremAssets.min === "number")
                onPremInputProps.min = String(fieldState.onPremAssets.min);
              if (typeof fieldState.onPremAssets.max === "number")
                onPremInputProps.max = String(fieldState.onPremAssets.max);
              onPremInputProps.type = "text";
              onPremInputProps.inputMode = "numeric";
              onPremInputProps.pattern = "[0-9]*";
              return (
                <TextField
                  id="On-prem Assets"
                  label="On-prem Assets"
                  variant="outlined"
                  required
                  fullWidth
                  name="onPremAssets"
                  InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // Only allow digits
                    formik.setFieldValue("onPremAssets", value);
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.onPremAssets}
                  disabled={fieldState.onPremAssets.disabled}
                  inputProps={onPremInputProps}
                />
              );
            })()}
          </Box>
          <Box display="flex" gap={2}>
            {/* Cloud Resources */}
            {(() => {
              const cloudInputProps: Record<string, string> = {};
              if (typeof fieldState.cloudResources.min === "number")
                cloudInputProps.min = String(fieldState.cloudResources.min);
              if (typeof fieldState.cloudResources.max === "number")
                cloudInputProps.max = String(fieldState.cloudResources.max);
              cloudInputProps.type = "text";
              cloudInputProps.inputMode = "numeric";
              cloudInputProps.pattern = "[0-9]*";
              return (
                <TextField
                  sx={{ mt: 2 }}
                  id="Cloud Resources"
                  label="Cloud Resources"
                  variant="outlined"
                  required
                  fullWidth
                  name="cloudResources"
                  InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // Only allow digits
                    formik.setFieldValue("cloudResources", value);
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.cloudResources}
                  disabled={fieldState.cloudResources.disabled}
                  inputProps={cloudInputProps}
                />
              );
            })()}
            {/* validity days - Date Range Picker */}
            <Box sx={{ width: "100%" }}>
              <TextField
                sx={{ mt: 2 }}
                id="expired-date"
                label="Expired (in days) *"
                variant="outlined"
                fullWidth
                name="expiredDate"
                InputLabelProps={{ sx: { fontWeight: 700, color: "black" } }}
                value={
                  dateRange[1]
                    ? dateRange[1].format("DD/MM/YYYY")
                    : ""
                }
                onClick={(e) => {
                  if (!fieldState.validity.disabled) {
                    setDateRangeAnchor(e.currentTarget);
                  }
                }}
                disabled={fieldState.validity.disabled}
                error={formik.touched.validity && Boolean(formik.errors.validity)}
                helperText={
                  formik.touched.validity && formik.errors.validity
                    ? formik.errors.validity
                    : dateRange[0] && dateRange[1]
                      ? `${dateRange[1].diff(dateRange[0], "day")} days from today`
                      : formik.values.validity
                        ? `Today to end date (${formik.values.validity} days)`
                        : "Today to end date (14 days)"
                }
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!fieldState.validity.disabled) {
                            setDateRangeAnchor(e.currentTarget);
                          }
                        }}
                        edge="end"
                        disabled={fieldState.validity.disabled}
                      >
                        <CalendarTodayIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Popover
                open={Boolean(dateRangeAnchor)}
                anchorEl={dateRangeAnchor}
                onClose={() => setDateRangeAnchor(null)}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  sx: {
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                  },
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Select end date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      value={dateRange[1]}
                      onChange={(newValue) => {
                        if (newValue) {
                          const newRange: [Dayjs | null, Dayjs | null] = [
                            dateRange[0],
                            newValue,
                          ];
                          setDateRange(newRange);
                          if (newRange[0] && newRange[1]) {
                            const days = newRange[1].diff(newRange[0], "day");
                            formik.setFieldValue("validity", days.toString());
                            formik.setFieldTouched("validity", true);
                          }
                          setDateRangeAnchor(null);
                        }
                      }}
                      minDate={dayjs()} // Today for all subscription types (validation enforces minimums)
                      maxDate={
                        (() => {
                          const subType = formik.values.subscriptionType.trim();
                          if (subType === "Free Trial") {
                            return dayjs().add(14, "day");
                          } else if (subType === "Free Custom") {
                            return dayjs().add(90, "day"); // Max 3 months from today
                          } else if (subType === "Paid Custom") {
                            return dayjs().add(365, "day"); // Max 12 months from today
                          }
                          return undefined;
                        })()
                      }
                      disabled={fieldState.validity.disabled}
                    />
                  </LocalizationProvider>
                </Box>
              </Popover>
            </Box>
          </Box>
          <Box
            mt={3}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Box
              sx={(theme) => ({
                display: "flex",
                height: 40,
                alignItems: "center",
                bgcolor: theme.palette.mode === "dark" ? "#181818" : "#f5f5f5",
                width: "100%",
                borderRadius: 2,
                justifyContent: "space-between",
              })}
            >
              <Typography variant="body2" sx={{ ml: 2, fontWeight: 500 }}>
                Enable SSO
              </Typography>
              <div style={{ marginRight: 10 }}>
                <AntSwitch
                  checked={formik.values.sso_enabled}
                  onChange={(event) => {
                    formik.setFieldValue("sso_enabled", event.target.checked);
                  }}
                />
              </div>
            </Box>
          </Box>
          <FrameworkSwitches
            value={formik.values.frameworks}
            onChange={(next) => formik.setFieldValue("frameworks", next)}
          />
          <Box mt={3} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="small"
              sx={{ minWidth: 100, minHeight: 35 }}
              disabled={!formik.isValid || !formik.dirty}
            >
              Invite
            </Button>
          </Box>
        </form>
      </div>
    </div>
  );
};

export default InviteOrgDrawer;
